import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import palette from './palette'

const theme = createTheme({
  palette,
  direction: 'rtl',
  spacing: 2,
  typography: {
    allVariants: {
      fontFamily: 'IRANSans',
    },
    h1 : {
      fontSize : 40 ,
      fontWeight : 450
    } ,
    h5 : {
      fontSize : 18 ,
      fontWeight : 490
    } ,
    h6 : {
      fontSize : 16 ,
      fontWeight : 490
    } ,
    body1 : {
      fontSize : 14 ,
    } ,
    subtitle1 : {
      fontSize : 15 ,
      fontWeight : 450
    }
  },
})

export default responsiveFontSizes(theme)
